import React from 'react';
 import './modalProgress.css';

import logoPretzu from '../../assets/logos_pretzu/logo_pretzu_sin_fondo.png';

//Mui material
import Dialog from '@mui/material/Dialog';
import { CircularProgress } from '@mui/material';

export const ModalProgress = () => {
  return (
    <>

      <Dialog
        className='ContainerProgress'
        open={true}
        //onClose={handleClose}
        scroll={'paper'}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <div className='SubContainerProgresss'>
          <div className='SubContainerProgress2'>
            <div className='ContainerLogoProgress'>
              <img className='ImgModalProgress' src={logoPretzu} alt='Logo Pretzu' />
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress className='Progress' size={80} />
            </div>
          </div>
        </div>

      </Dialog>
    </>
  );
};